import { IconType } from '@react-icons/all-files/lib';
import { ProgressStatus, STEP } from '@insurgrid/common';

export enum QueryKey {
  AgentInfo = 'agentInfo',
  AgentSettings = 'agentSettings',
  Client = 'client',
  Uuid = 'uuid',
  CarrierList = 'carrierList',
  SubCarrierList = 'subCarrierList',
  Dwellings = 'dwellings',
  Drivers = 'drivers',
  AddressResults = 'address-results',
  Submissions = 'submissions',
  CustomLink = 'custom-link',
}

export const MANUAL_UPLOAD_SUCCESS_TYPE = 'manual_upload';

export enum SuccessType {
  ManualUpload = 'manual_upload',
  Success = 'success',
  ManualMfa = 'manual_mfa',
}

export interface PersonalData {
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface DriverData {
  firstName?: string;
  lastName?: string;
}

export type ProgressData =
  | string[]
  // | PersonalData
  | DriverData[]
  | undefined;

export type ProgressDataMap = {
  // [STEP.personal]: PersonalData;
  [STEP.submission]: string[];
  [STEP.driver]: DriverData[];
  [STEP.property]: string[];
  [STEP.agentQuestions]: undefined;
  [STEP.summary]: undefined;
  [STEP.finished]: undefined;
};

export type Progress = [
  // ProgressStep<STEP.personal>,
  ProgressStep<STEP.submission>,
  ProgressStep<STEP.driver>,
  ProgressStep<STEP.property>,
  ProgressStep<STEP.agentQuestions>,
  ProgressStep<STEP.summary>,
  ProgressStep<STEP.finished>,
];

export interface ProgressStep<step extends STEP = STEP> {
  step: step;
  name: string;
  helperText: string;
  status: ProgressStatus;
  icon: IconType;
  data?: ProgressDataMap[step];
}
